import React from 'react'
import Try from './Try'
import Navbar from '../Components/NavBar'
import Layout from '../Components/Layout'
import MySkills from '../Components/MySkills'


const Skills = () => {


  return (
    <Layout title='Sarvadnya || Skills' >
      <div className=' relative min-h-screen  '>
        <Try />
        <Navbar />

        <MySkills />

      </div>
    </Layout>
  )
}

export default Skills